<template>
  <div>
    <v-form ref="refMain">
      <v-container class="px-3 py-0" fluid>
        <v-row fluid>
          <v-col cols="12" sm="5" md="4" lg="4" class="pa-0">
            <v-menu
                v-model="dFInicioMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFInicio"
                    label="Fecha Generado Desde"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFInicio"
                  @input="dFInicioMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" class="pa-0">
            <v-menu
                v-model="dFFinMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFFin"
                    label="Fecha Generado Hasta"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFFin"
                  @input="dFFinMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" class="pa-0">
            <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="primary" dark x-large style="border-radius: 0;"><v-icon>search</v-icon> Buscar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card>
      <v-data-table
          :headers="dTable.headers"
          :items="dItems"
          :loading="dTable.loading"
          :search="dTable.search"
          class="elevation-1"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title><v-btn @click.prevent="enviarJson" color="primary" block><v-icon>send</v-icon> Enviar</v-btn></v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title><v-btn @click.prevent="eliminarJson(item.id)" color="error" block><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.estado`]="{ value }">
          <v-chip
              close-icon="mdi-close-outline"
              :color="value ? 'primary' : 'red'"
              text-color="#ffffff"
              pill
          >{{ value ? 'Enviado' : 'No Enviado' }}</v-chip>
        </template>
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import gql from "graphql-tag";
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
  data: () => ({
    dFInicio: moment().subtract(30,'d').format('YYYY-MM-DD'),
    dFInicioMenu: false,
    dFFin: moment().format('YYYY-MM-DD'),
    dFFinMenu: false,
    dTable: {
      headers: [
        {value: 'actions', text: '...', sortable: false},
        {value: 'id', text: 'Id', align: ' d-none'},
        {value: 'tipo', text: 'Tipo'},
        {value: 'fecha', text: 'Fecha Generado'},
        {value: 'estado', text: 'Estado'},
      ],
      loading: false,
      search: null,
    },
    dItems: [],
  }),
  mounted(){
    this.fListarJsons();
  },
  methods: {
    async fListarJsons()  {
      this.dTable.loading = true

      try {
        const response = await this.$apollo.query({
          query: gql`query {
            jsonsMinedu { id, tipo, fecha, estado }
          }
          `,
        });

        this.dItems = response.data.jsonsMinedu
      } catch (error) {
        console.log(error)
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
      } finally {
        this.dTable.loading = false
      }
    },

    async fuSearch() {
    },

    async enviarJson() {
      let message = Swal.fire({
        title: 'Estas seguro de enviar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Enviar'
      })

      let response = await message;
      if (response.value) {

      }
    },

    async eliminarJson(id) {
      let message = Swal.fire({
        title: 'Estas seguro de eliminar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar'
      })

      let response = await message;
      if (response.value) {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation eliminar($id: Int!) {
            eliminarJsonMinedu(id: $id){
              codError, message
            }
          }`,
          variables: {
            id: id
          }
        })

        const codError = response.data.eliminarJsonMinedu.codError;
        const message = response.data.eliminarJsonMinedu.message;

        console.log(codError,message)
      }
    }
  }
}
</script>